export default __webpack_public_path__ + "static/media/IF_MySalesStyle_StrengthArea_01.20b92f30.jpg";